import styled from 'styled-components';

/**
 * PageContainer - A reusable page container with theme-aware background
 *
 * Usage:
 * import PageContainer from 'components/PageContainer';
 *
 * const MyPage = () => (
 *   <EnhancedThemeProvider>
 *     <PageContainer>
 *       <Card>...</Card>
 *     </PageContainer>
 *   </EnhancedThemeProvider>
 * );
 *
 * Props:
 * - maxWidth: string - Maximum width of the container (default: '1400px')
 * - noPadding: boolean - Remove default padding
 * - fullWidth: boolean - Remove max-width constraint
 * - centered: boolean - Center the container (default: true)
 */
const PageContainer = styled.div`
  padding: ${(props) => (props.noPadding ? '0' : '24px')};
  max-width: ${(props) =>
    props.fullWidth ? 'none' : props.maxWidth || '1400px'};
  margin: ${(props) => (props.centered !== false ? '0 auto' : '0')};
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: ${(props) => (props.noPadding ? '0' : '16px')};
  }
`;

export default PageContainer;
